import navBarHomepage from '../modules/navbar-homepage';
import searchClearForm from '../modules/search-clear-form';
import searchImageError from '../modules/search-image-error';
let searchController = () => {
    navBarHomepage.on();
    searchClearForm.on();
    searchImageError();
};

export default searchController;
